const getA2PComplianceStatus = function (state) {
  const { a2pComplianceStatus } = state
  return a2pComplianceStatus ? a2pComplianceStatus : ''
}

export default getA2PComplianceStatus
